var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.getObjects()),function(v){return _c('li',{key:v.id},[_vm._v("\n\t\t\t"+_vm._s(v.label)),(v.deleted)?_c('span',{attrs:{"title":_vm.t('tables', 'This option is outdated.')}},[_vm._v(" ⚠️")]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }